const CommonReelStructure = {
    accUserId: "",
    accProfileImage: "",
    reellist: [
        {
            reelid: null, // Unique Reel ID
            userId: "", // User who uploaded the reel
            videoUrl: "", // Video URL of the reel
            description: "", // Optional description of the reel
            thumbnail: "", // Thumbnail image URL
            date: "", // ISO Date-Time string (e.g., "2025-02-17T14:30:00Z")
            location: "", // Location where the reel was uploaded (if available)
            likesCount: 0, // Number of likes
            commentsCount: 0, // Number of comments
            impressions: 0, // Number of times the reel has been viewed
            comments: [
                {
                    userId: "", // User who commented
                    text: "", // Comment text
                    date: "" // ISO Date-Time string
                }
            ]
        }
    ]
};

export default CommonReelStructure;
